import { render, staticRenderFns } from "./TriangleCricle.vue?vue&type=template&id=0fa32d68&"
import script from "./TriangleCricle.vue?vue&type=script&lang=js&"
export * from "./TriangleCricle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports